import { render, staticRenderFns } from "./subjectModal.vue?vue&type=template&id=3c8e879a&scoped=true&"
import script from "./subjectModal.vue?vue&type=script&lang=js&"
export * from "./subjectModal.vue?vue&type=script&lang=js&"
import style0 from "./subjectModal.vue?vue&type=style&index=0&id=3c8e879a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e879a",
  null
  
)

export default component.exports